import gql from 'graphql-tag';

export const GET_INVITE_CODE_AGENT_TAB = gql`
	query GetInviteCodeAgentTab($q: JSON!, $limit: Int, $offset: Int) {
		forms(query: $q, limit: $limit, offset: $offset) {
			id
			inviteCode
			salesman {
				id
				name
				image
			}
		}
	}
`;
